import { useRef, useEffect, useState } from 'react';

const testimonials = [
  {
    name: 'Jennifer & David Park',
    location: 'Duluth, GA',
    rating: 5,
    text: 'Shawn Kim helped us find our dream home in Duluth within 3 weeks. His deep knowledge of the local school districts was invaluable. We felt completely guided through every step of the process.',
    flag: '🇺🇸',
  },
  {
    name: '이민준 · 이지영',
    location: '스와니, GA',
    rating: 5,
    text: '김산 부동산 덕분에 스와니에서 완벽한 집을 찾았습니다. 학군과 집값 모두 저희가 원하던 조건 그대로였어요. 처음부터 끝까지 세심하게 챙겨주셔서 정말 감사했습니다.',
    flag: '🇰🇷',
  },
  {
    name: 'Michael Thompson',
    location: 'Atlanta, GA',
    rating: 5,
    text: 'Shawn\'s expertise in commercial real estate helped me acquire the perfect retail property in Atlanta. His negotiation skills saved me over $80,000 on the final deal. Absolutely recommend.',
    flag: '🇺🇸',
  },
  {
    name: '박수현 · 박지수',
    location: '둘루스, GA',
    rating: 5,
    text: '미국에서 처음 집을 사는 거라 걱정이 많았는데, 김산 선생님께서 처음부터 끝까지 한국어로 설명해주시고 최선을 다해 도와주셔서 정말 편안하게 진행할 수 있었습니다. 강력 추천드려요!',
    flag: '🇰🇷',
  },
  {
    name: 'Sarah & James Kim',
    location: 'Suwanee, GA',
    rating: 5,
    text: 'We sold our Suwanee home in just 12 days at $45,000 above asking price. Shawn\'s marketing strategy and pricing expertise were exceptional. Professional, responsive, and truly cares about clients.',
    flag: '🇺🇸',
  },
  {
    name: '최영호',
    location: '애틀란타, GA',
    rating: 5,
    text: '투자용 부동산을 찾고 있었는데 Shawn Kim 브로커님이 최적의 매물을 추천해 주셨습니다. 덕분에 좋은 수익률로 투자할 수 있었고, 앞으로도 계속 함께 하고 싶습니다.',
    flag: '🇰🇷',
  },
];

export default function TestimonialsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#B8963E] text-xs font-bold tracking-widest uppercase mb-3">Client Reviews · 고객 후기</p>
          <h2 className="font-['Playfair_Display'] text-[#1A1A1A] text-3xl lg:text-4xl font-bold mb-4">
            What Our Clients Say
          </h2>
          <p className="text-[#666] text-sm max-w-lg mx-auto">
            Trusted by hundreds of families and investors in the Atlanta metro area for over three decades.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div
              key={t.name}
              className={`bg-[#F8F6F1] rounded-lg p-7 transition-all duration-500 ${
                index === current ? 'ring-2 ring-[#B8963E]' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#B8963E] text-sm"></i>
                ))}
              </div>
              <p className="text-[#444] text-sm leading-relaxed mb-5 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-[#EDE8DF]">
                <div className="w-10 h-10 flex items-center justify-center bg-[#B8963E]/15 rounded-full text-lg">
                  {t.flag}
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#1A1A1A]">{t.name}</div>
                  <div className="text-xs text-[#888]">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                i === current ? 'bg-[#B8963E] w-6' : 'bg-[#D0C8BC]'
              }`}
              aria-label={`Go to testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
